import { create } from "zustand";

export const useSidebarStore = create((set, get) => ({
  isSidebarExpanded: true,
  wasCollapsed: false,
  openDropdown: null,

  handleSidebarMouseEnter: () =>
    set((state) => ({
      wasCollapsed: !state.isSidebarExpanded,
      isSidebarExpanded: true,
    })),

  handleSidebarMouseLeave: () =>
    set((state) => ({
      isSidebarExpanded: state.wasCollapsed ? false : state.isSidebarExpanded,
      wasCollapsed: false,
    })),

  toggleSidebar: () =>
    set((state) => ({
      isSidebarExpanded: !state.isSidebarExpanded,
    })),

  setSidebarExpanded: (expanded) => set({ isSidebarExpanded: expanded }),

  toggleDropdown: (dropdownId) =>
    set((state) => ({
      openDropdown: state.openDropdown === dropdownId ? null : dropdownId,
    })),

  setOpenDropdown: (dropdownId) => set({ openDropdown: dropdownId }),

  closeDropdown: () => set({ openDropdown: null }),
}));
